<template>
  <div class="page" :style="getStyles">
    <navbar
      equal-items
      :text-color="this.page ? this.page.field_text_color[0].value : null"
    >
      <li class="narrow-on-mobile">
        <router-link to="/">Index</router-link>
      </li>
      <li class="text-right" v-if="page">
        <div v-html="page.field_topbar_2[0].value"></div>
      </li>
    </navbar>

    <template v-if="page">
      <div class="page-container regular-text">
        <div v-html="page.body[0].value"></div>
      </div>
    </template>
  </div>
</template>


<script>
import Navbar from "@/components/Navbar";

export default {
  data() {
    return {
      page: null,
    };
  },

  components: {
    Navbar,
  },

  computed: {
    getStyles() {
      return {
        "--page-background-color": this.page
          ? this.page.field_background_color[0].value
          : null,
        "--page-text-color": this.page
          ? this.page.field_text_color[0].value
          : null,
      };
    },
  },

  async mounted() {
    this.$Progress.set(10);

    const pages = this.$store.state.pages;

    this.page = pages.find((page) => {
      return page.field_slug[0].value == this.$route.params.slug;
    });

    this.$Progress.finish();

    setTimeout(() => {
      this.$emit("ready");
    }, 700);

    // Prerendering
    // https://github.com/chrisvfritz/prerender-spa-plugin
    document.dispatchEvent(new Event("page-rendered"));
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("before-route-leave", function () {
      next();
    });
  },
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";
.page {
  height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  color: var(--page-text-color, #000);
  background-color: var(--page-background-color, #fff);

  .page-container {
    @include breakpoint(xs) {
      padding: var(--page-padding-mobile);
    }

    @include breakpoint(sm) {
      padding: var(--page-padding-tablet);
    }

    @include breakpoint(md) {
      padding: var(--page-padding);
    }
    flex-grow: 1;
    background-color: var(--page-background-color-default);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>